<template>
  <div class="card goal-card" 
    :style="{'background-color': goal.color || 'orange'}" 
    :class="{'abandoned': goal.abandoned}"
    v-if="!small">
    <div class="goal-info">
      <h3 style="overflow: auto">{{goal.goal}}</h3>
      <div v-if="goal.completed">
        <h3>Completed On</h3>
        <h4>{{completedAt}}</h4>
      </div>
      <h4 v-if="goal.abandoned">This goal was abandoned</h4>
      <!-- <div>
        <div class="row small-top align-center">
          <h3 class="small-right">Began</h3>
          <div>{{goal.startedOn}}</div>
        </div>
        <div class="row small-top flex-end" v-if="goal.deadline">
          <h3 class="small-right">Goal Date</h3>
          <div>{{goal.deadline}}</div>
        </div>
      </div> -->
      <button v-if="editable" class="btn btn--outline" @click="complete(goal)">
        {{btnText}}
      </button>
    </div>
    <div>
      <div style="font-size: 18px">Milestones</div>
      <div class="milestone-wrapper">
        <div @click="completeMilestone(milestone)" class="clickable milestone" v-for="milestone in goal.milestones" :key="milestone.id">
          <span class="circle progress-circle" v-if="!milestone.completed"></span>
          <i class="material-icons progress-circle" v-else>check_circle</i>
          <div>{{ milestone.text }}</div>
        </div>
        <div class="milestone" :class="{clickable: allMilestonesCompleted}" @click="completeGoal">
          <span class="circle progress-circle" v-if="!goal.completed"></span>
          <i class="material-icons progress-circle" v-else>check_circle</i>
          <div>{{ goal.goal}}</div>
        </div>
      </div>
    </div>
    <chart style="max-width: 30%" :percent="percent" />
    <button  v-if="editable" class="col" style="position: absolute; top: 8px; right: 8px;" @click="editGoal=true">
      <i class="material-icons">edit</i>
      <div>Edit</div>
    </button>
    <button v-if="editable" @click="$emit('remove')" class="col" style="position: absolute; bottom: 8px; right: 8px;">
      <i class="material-icons">delete</i>
      <div>Delete</div>
    </button>
    <goal-modal :goal="goal" v-if="editGoal" @close="editGoal=false" @saved="editGoal=false" />
    <modal v-if="displayWarning">
      <div class="card card--white card--relative">
        <h-icon class="close clickable" @click="displayWarning=false">close</h-icon>
        <div class="card--container">
          Before completing your goal, you must first complete all the goal's milestones.
        </div>
      </div>
    </modal>
  </div> 

  <div v-else class="card goal-card"  :style="{'background-color': goal.color || 'orange'}" >
    <div class="flex-end">
      <button v-if="editable" @click="editGoal=true" style="margin-right: 15px">
        <i class="material-icons">edit</i>
      </button>
      <button v-if="editable" @click="$emit('remove')">
        <i class="material-icons">delete</i>
      </button>
    </div>
    <h3 style="overflow: auto">{{goal.goal}}</h3>
    <h3>Milestones</h3>
    <div class="milestone-wrapper">
      <div class="milestone" @click="completeMilestone(milestone)" :class="{clickable: !milestone.completed}" v-for="milestone in goal.milestones" :key="milestone.id">
        <span class="circle progress-circle" v-if="!milestone.completed"></span>
        <i class="material-icons progress-circle" v-else>check_circle</i>
        <div>{{ milestone.text }}</div>
      </div>
      <div class="milestone" :class="{clickable: allMilestonesCompleted}" @click="completeGoal">
        <span class="circle progress-circle" v-if="!goal.completed"></span>
        <i class="material-icons progress-circle" v-else>check_circle</i>
        <div>{{ goal.goal}}</div>
      </div>
    </div>
    <button v-if="editable" class="btn btn--outline" @click="complete(goal)">
      {{btnText}} 
    </button>
    <goal-modal :goal="goal" v-if="editGoal" @close="editGoal=false" @saved="editGoal=false" />
    <modal v-if="displayWarning">
      <div class="card card--white card--relative">
        <h-icon class="close clickable" @click="displayWarning=false">close</h-icon>
        <div class="card--container">
          Before completing your goal, you must first complete all the goal's milestones.
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import snackbar from "@/services/hubs/snackbar";
import raffleHub from "@/services/hubs/raffle";
import dataStore from "@/services/api/store";
import goalModal from "./goalModal";
import modal from "@/components/modal";
import chart from "./chart";
import moment from 'moment';

export default {
  components: { goalModal, chart, modal },
  props: { goal: Object, editable: { default: true, type: Boolean } },
  data() {
    return {
      editGoal: false,
      percent: 0,
      displayWarning: false,
      small: window.innerWidth < 600
    };
  },
  created() {
    this.calcPercent();
  },
  methods: {
    completeGoal() {
      if (!this.allMilestonesCompleted) {
        this.displayWarning = true;
        return;
      }
      this.goal.completed = true;
      this.goal.save().then(() => {
        raffleHub.update("goal");
        snackbar.update("Saved");
      });
      this.$emit("complete");
      this.percent = 100;

    },
    completeMilestone(milestone) {
      if (milestone.completed) {
        return;
      }
      milestone.completed = true;
      snackbar.update("Saved");
      this.calcPercent();
      dataStore.update("ClientMilestones", milestone.id, {completed: true}, {method: "patch"})
        .then(() => {
          raffleHub.update("milestone");
        });
    },
    complete() {
      let milestone = this.goal.milestones.find(milestone => !milestone.completed);
      if (!milestone) {
        this.completeGoal();
        return;
      }
      this.completeMilestone(milestone);
    },
    calcPercent() {
      let completed = this.goal.milestones.filter(m => m.completed).length;
      if (this.goal.completed) {
        completed += 1;
      }
      let total = this.goal.milestones.length + 1;
      this.percent = Number.parseInt(100 * (completed / total));
    }
  },
  computed: {
    btnText() {
      if (this.goal.milestones.filter(m => !m.completed).length) {
        return "Complete Milestone";
      }
      return "Complete Goal";
    },
    allMilestonesCompleted() {
      return this.goal.milestones.every(m => m.completed);
    },
    completedAt() {
      if (this.goal.completed) {
        return moment(this.goal.modified_at).format('ll')
      }
    }
  }
};
</script>

<style lang="less" scoped>
.goal-card {
  color: white;
  display: flex;
  flex-direction: row;
  height: 30vh;
  min-height: 20vh;
  padding: 1.5em;
  position: relative;
  & + .abandoned {
    filter: brightness(0.8);
  }

  @media (max-width: 600px) {
    flex-direction: column;
    height: 100%;
    max-height: none;
    .milestone-wrapper {
       max-height: none;
      //  overflow-y: none;
    }
  }

  .goal-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 35%;
    margin-right: 30px;
    .goal {
      font-size: 18px;
      font-weight: 800;
      text-transform: uppercase;
    }
  }


  h3, h4 {
    color: white;
    font-weight: 800;
  }

  > div {
    flex: 1;
    margin-right: 5px;
  }

  .milestone-wrapper {
    margin-left: 10px;
    max-height: 70%;
    overflow-y: auto;
    margin-top: 15px;
    padding: 10px;

    .milestone {
      border-left-style: solid;
      border-left-color: rgba(255, 255, 255, .4);
      border-left-width: 2px;
      position: relative;
      padding-bottom: 30px;
      padding-left: 20px;
      padding-top: 0px;
      font-size: 18px;

      .progress-circle {
        border-radius: 50%;
        display: inline-block;
        position: absolute;
        left: -12px;
        top: 0px;
      }


      .circle {
        height: 21px;
        width: 21px;
        background-color: rgba(255, 255, 255, 1);
        // background-color: white;
      }
    }
    .milestone:last-child {
      padding-bottom: 0px;
    }
  }
}

</style>
